<template>
  <body class="report-c408-offline">
    <div class="container" style="position: relative">
      <div class="image-template"></div>
      <div class="prevent-name-product-footer"></div>
      <div class="header-block edit-block page-margin-content" style="padding-bottom: 6px">
        <div class="header">
          <table cellpadding="0" cellspacing="0" style="width: 100%" class="table-valign-top">
            <tbody>
              <tr>
                <td colspan="5" class="logo-company-center hidden">
                  <div class="logo-company logo-template center ui-resizable ui-draggable ui-draggable-handle">
                    <div
                      class="ui-resizable-handle ui-resizable-se ui-icon ui-icon-gripsmall-diagonal-se"
                      style="z-index: 90"
                    ></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="logo-company-left default hidden" style="width: 10px">
                  <div class="logo-company logo-template left ui-resizable ui-draggable ui-draggable-handle">
                    <div
                      class="ui-resizable-handle ui-resizable-se ui-icon ui-icon-gripsmall-diagonal-se"
                      style="z-index: 90"
                    ></div>
                  </div>
                </td>
                <td>
                  <div></div>
                </td>
                <td class="text-center" style="width: 280px">
                  <div class="template-number" style="margin-left: 10px">
                    <div class="" data-group="template-number">
                      <div data-readonly="true" data-field="template-no">
                        <span class="edit-field bc-form-no">Mẫu số C4-08/KB</span>
                      </div>
                      <div class="ct-issue-by" data-readonly="true" data-field="template-description">
                        <span class="edit-field">
                          (Theo TT số 19/2020/TT-BTC ngày 31/3/2020<br />
                          của Bộ trưởng Bộ Tài chính)
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="logo-company-right hidden" style="width: 10px">
                  <div class="logo-company logo-template right ui-resizable ui-draggable ui-draggable-handle">
                    <div
                      class="ui-resizable-handle ui-resizable-se ui-icon ui-icon-gripsmall-diagonal-se"
                      style="z-index: 90"
                    ></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="invoice-title row">
          <div class="relative">
            <span class="absolute block-border-empty">Không ghi vào khu vực này</span>
          </div>
          <div class="text-center" style="max-width: 60%; flex: 2; margin-left: 128px">
            <div class="edit-group text customizable" data-group="title">
              <div class="edit-item report-title bc-title" data-field="title" style="width: 100%">
                <span class="edit-field">GIẤY NỘP TIỀN VÀO TÀI KHOẢN</span>
              </div>
              <div
                class="edit-item value-only report-sub-title-italic"
                data-readonly="true"
                data-field="ref_date"
                data-formattype="14"
                data-label="Lập ngày .... tháng .... năm ...."
              >
                <span class="edit-field" data-text="Lập ngày .... tháng .... năm ...." data-title-date="true"></span
                ><span class="edit-value data-value ref_date">{{ model.txtValueDate }}</span>
              </div>
            </div>
          </div>
          <div class="flex relative" style="font-size: 10pt">
            <div class="absolute" style="left: 32px">
              <div class="edit-group text ct-text-frame" data-group="no">
                <div class="edit-item" data-field="debit_account">
                  <span class="edit-field">Số:&nbsp;</span
                  ><span class="edit-value data-value" style="display: inline">{{ model.ref_no }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="line-height: 1.5">
          <div class="">
            <div class="row">
              <div class="flex-3 edit-group text customizable" style="margin-top: 10px" data-group="master">
                <div class="edit-item w-100 print-text-left" data-field="accounting_object_name">
                  <span class="edit-field" style="display: inline">Người nộp:&nbsp;</span
                  ><span class="edit-value data-value" style="display: inline">{{ model.accounting_object_name }}</span>
                </div>
                <div class="edit-item w-100 print-text-left" data-field="accounting_object_address">
                  <span class="edit-field" style="display: inline">Địa chỉ:&nbsp;</span
                  ><span class="edit-value data-value" style="display: inline">{{
                    model.accounting_object_address
                  }}</span>
                </div>
                <div class="edit-item w-100 print-text-left" data-field="bank_account">
                  <span class="edit-field" style="display: inline">Nộp vào tài khoản số:&nbsp;</span
                  ><span class="edit-value data-value" style="display: inline">{{ model.bank_account }}</span>
                </div>
                <div class="edit-item w-100 print-text-left" data-field="CompanyName">
                  <span class="edit-field" style="display: inline">Đơn vị nhận tiền:&nbsp;</span
                  ><span class="edit-value data-value" style="display: inline">{{ model.CompanyName }}</span>
                </div>
              </div>
              <div class="flex relative" parent-group="master-p2">
                <div
                  style="border: 1px solid; height: fit-content; padding-bottom: 12px; left: 0"
                  class="absolute block-border-empty-2 edit-group text customizable"
                  parent-group="master-2"
                  data-group="master-2"
                >
                  <div
                    class="edit-item w-100 text-center"
                    header-group="master-2"
                    data-field="title-1"
                    style="
                      border-bottom: 1px solid;
                      font-size: 11pt;
                      font-weight: bold;
                      text-align: center;
                      margin-bottom: 12px;
                    "
                  >
                    <span class="edit-field">PHẦN KBNN GHI</span>
                  </div>
                  <div class="edit-item" data-field="debit_acc" header-group="master-2">
                    <span class="edit-field">Nợ TK:</span
                    ><span class="data-value" style="display: inline">....................</span>
                  </div>
                  <div class="edit-item" data-field="crebit_acc" header-group="master-2">
                    <span class="edit-field">Có TK:</span
                    ><span class="data-value" style="display: inline">....................</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="edit-group text customizable" data-group="master-3">
            <div class="edit-item w-100 print-text-left" data-field="treasury_bank_name">
              <span class="edit-field" style="display: inline">Tại KBNN:&nbsp;</span
              ><span class="edit-value data-value" style="display: inline">{{ model.bank_name_KB }}</span>
            </div>
            <div class="edit-item w-100 print-text-left" data-field="delegate_bank_name">
              <span class="edit-field" style="display: inline">Mở tại Ngân hàng ủy nhiệm thu:&nbsp;</span
              ><span class="edit-value data-value" style="display: inline">
                {{ model.bank_name }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-group text customizable table" data-group="table">
        <ms-grid-viewer
          :columns="columnsReport"
          class="plr-20 bg-white pt-1"
          :filterable="false"
          :ref="viewRef"
          :data="model.dataDetail"
          idField=""
          :loading="loading"
          v-on="_gridEvent"
          :lockable="false"
          :footer="false"
          :queryMode="'local'"
        >
        </ms-grid-viewer>
        <!-- <table cellpadding="0" cellspacing="0" style="width: 100%" class="table-report table-detail">
          <thead>
            <tr class="">
              <td style="width: 530px" class="bc-table-header text-center">Nội dung nộp</td>
              <td class="bc-table-header text-center">Số tiền</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="n in model.dataDetail" :key="n" :index="n">
              <td
                v-for="(sc, i) in shimmerColumn"
                :key="i"
                :class="{sticky: sc.lock}"
                :style="{
                  left: typeof sc.offset == 'number' ? sc.offset + 'px' : 'unset',
                  borderRight: '1px dotted #c1c4cc',
                }"
              >
                <div class="shimmer"></div>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
      <div class="edit-block page-margin-content page-end">
        <div class="edit-group text customizable breakable" data-group="m1" style="padding-top: 10px">
          <div class="edit-item w-100 print-text-left" data-field="totalAmountWords">
            <span class="edit-field ct-summary-text-number">Tổng số tiền ghi bằng chữ:&nbsp;</span
            ><span class="edit-value data-value ct-summary-text-number" style="display: inline">{{
              model.strTotalAmount
            }}</span>
          </div>
          <div style="margin: 15px 0px 0px 0px; border-top: 1px solid"></div>
        </div>
        <div class="edit-group text customizable breakable" data-group="m2" style="padding-top: 10px">
          <div
            class="text-right edit-item"
            data-label="Ngân hàng/KBNN"
            data-field="created"
            style="width: 100%; font-style: italic"
          >
            <span class="edit-field">Ngân hàng/KBNN</span><span> &nbsp;{{ model.txtDateSign }} </span>
          </div>
        </div>
        <div>
          <div class="edit-group sign breakable" data-group="sign">
            <div class="footer">
              <table class="w-100 tb-sign">
                <tbody>
                  <tr class="edit-item">
                    <td
                      style="width: 25%"
                      class="text-center sign-item"
                      data-field="payer_name"
                      data-label="NGƯỜI NỘP TIỀN"
                    >
                      <div class="sign-label">
                        <div class="edit-field ct-sign-title">NGƯỜI NỘP TIỀN</div>
                        <div class="ct-sign-subtitle">(Ký, ghi rõ họ tên)</div>
                      </div>
                    </td>
                    <td
                      style="width: 25%"
                      class="text-center sign-item"
                      data-readonly="true"
                      data-field="cashier"
                      data-label="THỦ QUỸ"
                    >
                      <div class="sign-label">
                        <div class="edit-field ct-sign-title">THỦ QUỸ</div>
                      </div>
                    </td>
                    <td
                      style="width: 25%"
                      class="text-center sign-item"
                      data-readonly="true"
                      data-field="reporter"
                      data-label="KẾ TOÁN"
                    >
                      <div class="sign-label">
                        <div class="edit-field ct-sign-title">KẾ TOÁN</div>
                      </div>
                    </td>
                    <td
                      style="width: 25%"
                      class="text-center sign-item"
                      data-field="chief_accountant"
                      data-label="KẾ TOÁN TRƯỞNG"
                    >
                      <div class="sign-label">
                        <div class="edit-field ct-sign-title">KẾ TOÁN TRƯỞNG</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <input style="display: none" type="file" accept="image/*" />
  </body>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import basePopup from '@/views/base/basePopup';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import msGridViewer from '@/components/gridViewer/MsGridViewer.vue';
import {ModuleBankInfo} from '@/stores/moduleConst';
import {defineComponent, onMounted, computed, reactive, ref, getCurrentInstance, watch} from 'vue';
import {mapGetters} from 'vuex';
import {ModuleContext} from '@/stores/moduleConst';
import commonFunction from '../../commons/commonFunction';
import {useReadNumber} from '@/commons/readNumber.js';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    msGridViewer,
  },
  extends: basePopup,
  name: 'C4-O8/KS',
  props: {
    dataReport: {
      default: {},
      type: Object,
    },
  },
  computed: {
    /**
     * Số lượng cột shimmer
     */
    shimmerColumn() {
      let res = [];
      res.push({
        offset: undefined,
        lock: undefined,
      });
      res.push({
        offset: undefined,
        lock: undefined,
      });
      return res;
    },
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
  },

  setup(props) {
    const {proxy} = getCurrentInstance();

    const {numberText} = useReadNumber();

    const model = reactive({
      txtValueDate: 'Lập ngày ...... tháng ...... năm .......',
      ref_no: '..............', // Số CT
      accounting_object_name:
        '......................................................................................................', // Người nộp
      accounting_object_address:
        '...........................................................................................................', // Địa chỉ
      bank_account: '......................................................................................', // Nộp vào tài khoản số
      CompanyName: '.............................................................................................', // Đơn vị nhận tiền (Lấy từ dbOption và phải có dữ liệu chi tiết mới hiển thị)
      bank_name_KB:
        '.................................................................................................................................................', //Tại KBNN (Nếu open_in_budget== true mới hiển thị)
      bank_name:
        '................................................................................................................', //Mở tại Ngân hàng ủy nhiệm thu (Nếu open_in_budget != true mới hiển thị)
      dataDetail: [
        {
          description: '',
          amount: 0,
        },
      ],
      strTotalAmount: '...................................................................', // TỔng tiền bằng chữ
      txtDateSign: 'ghi sổ ngày .... tháng .... năm ....', // ghi so ngay
    });
    onMounted(() => {
      dbOptions.value = {...proxy.$store.state.dbOption.dbOptions};
      genReportByRefType(proxy.dataReport);
    });

    const columnsReport = reactive([
      {
        title: 'Nội dung nộp',
        caption: 'Nội dung nộp',
        dataField: 'description',
        sortable: false,
      },
      {
        title: 'Số tiền',
        caption: 'Số tiền',
        dataField: 'amount',
        width: 200,
        sortable: false,
      },
    ]);
    const dbOptions = ref([]);
    /**
     * Format tiền
     */
    const formatAmount = amount => {
      return proxy.$ms.format.formatAmount(amount || 0, {
        optionFormat: proxy.$ms.constant.OptionFormat.ZeroToEmpty,
      });
    };
    /**
     * Case lấy dữ liệu báo cáo theo từng loại chứng từ
     */
    function genReportByRefType(data) {
      if (data?.dataVoucher?.ref_type) {
        switch (data.dataVoucher.ref_type) {
          case proxy.$ms.constant.RefType.BUTransferDeposit:
            genDataReport(data.dataVoucher, data?.dataParam);
            break;
          default:
            console.log(`Chưa khai báo hàm xử lý lấy dữ liệu cho loại chứng từ ${data.ref_type}`);
            break;
        }
      } else {
        console.log(`Chưa khai báo loại chứng từ`);
      }
    }

    /**
     * Gen dữ liệu in lên báo cáo
     */
    function genDataReport(data, dataParam) {
      const bankInfos = proxy.$store.getters[`${ModuleBankInfo}/items`];
      if (data.ref_date) {
        let strValueDate = `Lập ngày {0} tháng {1} năm {2}`;
        proxy.model.txtValueDate = strValueDate.format(
          data.ref_date.getDate() > 9 ? `${data.ref_date.getDate()}` : `0${data.ref_date.getDate()}`,
          data.ref_date.getMonth() > 8 ? `${data.ref_date.getMonth() + 1}` : `0${data.ref_date.getMonth() + 1}`,
          data.ref_date.getFullYear(),
        );
      }
      if (proxy.postedDate) {
        let strDateSign = `ghi sổ ngày {0} tháng {1} năm {2}`;
        proxy.model.txtDateSign = strDateSign.format(
          proxy.postedDate.getDate() > 9 ? `${proxy.postedDate.getDate()}` : `0${proxy.postedDate.getDate()}`,
          proxy.postedDate.getMonth() > 8
            ? `${proxy.postedDate.getMonth() + 1}`
            : `0${proxy.postedDate.getMonth() + 1}`,
          proxy.postedDate.getFullYear(),
        );
      }
      if (data.ref_no) {
        proxy.model.ref_no = data.ref_no;
      }
      if (data.accounting_object_name && data.accounting_object_name != '') {
        proxy.model.accounting_object_name = data.accounting_object_name;
      }
      if (data.accounting_object_address && data.accounting_object_address != '') {
        proxy.model.accounting_object_address = data.accounting_object_address;
      }
      if (data.accounting_object_bank_account && data.accounting_object_bank_account != '') {
        proxy.model.bank_account = data.accounting_object_bank_account;
      }
      if (data.accounting_object_bank_name && bankInfos?.length > 0) {
        let bankInfo = bankInfos.find(x => x.bank_account == data.accounting_object_bank_account);
        if (bankInfo?.open_in_budget && data.accounting_object_bank_name != '') {
          proxy.model.bank_name_KB = data.accounting_object_bank_name;
        }
        if (!bankInfo?.open_in_budget && data.accounting_object_bank_name != '') {
          proxy.model.bank_name = data.accounting_object_bank_name;
        }
      }
      let totalAmount = 0;
      if (data?.Detail?.length > 0) {
        if (dbOptions.value.CompanyName) {
          proxy.model.CompanyName = dbOptions.value.CompanyName;
        }
        let detailDataReport = data?.Detail?.filter(t => t.debit_account?.startsWith('112'));

        // Check điều kiện form tham số
        if (dataParam.is_summary_same) {
          // nếu tích chọn Cộng gộp các bút toán giống nhau
          let grDataDetail = commonFunction.getGroupByFuncKey(detailDataReport, x => ({
            debit_account: x.debit_account,
            credit_account: x.credit_account,
          }));
          proxy.model.dataDetail = Object.keys(grDataDetail)?.map(key => {
            const sumGr = grDataDetail[key].reduce((pre, cur) => {
              cur['amount'] = cur['amount'] ?? 0;
              pre = pre ?? 0;
              return pre + cur['amount'];
            }, 0);
            totalAmount += sumGr;
            let item = {
              description: data.journal_memo,
              debit_account: grDataDetail[key][0],
              amount: formatAmount(sumGr),
            };
            return item;
          });
        } else {
          proxy.model.dataDetail = detailDataReport?.map(x => {
            totalAmount += x.amount;
            let item = {
              description: x.description,
              amount: formatAmount(x.amount),
            };
            return item;
          });
        }

        proxy.model.dataDetail.push({
          description: 'Tổng cộng',
          amount: formatAmount(totalAmount),
        });
      }

      // Xử lý đọc tiền
      proxy.model.strTotalAmount = numberText(totalAmount);
      // emit ra component cha để
      proxy.$nextTick(() => {
        proxy.$nextTick(() => {
          let tr = proxy.$el.querySelectorAll('.ms-grid-viewer tr');
          const headerHeight = 290;
          const footerHeight = 240;
          const pageHeight = 1050;
          let totalHeight = headerHeight;
          tr.forEach(element => {
            totalHeight += element.getBoundingClientRect().height;
            if (totalHeight > pageHeight) {
              element.classList.add('html2pdf__page-break');

              if (element.nextElementSibling) {
                element.nextElementSibling.classList.add('border-top');
              }

              let trEmpty = document.createElement('tr');
              trEmpty.style.height = '35px';
              element.parentNode.insertBefore(trEmpty, element.nextElementSibling);
              totalHeight = 0;
            }
          });
          if (totalHeight + footerHeight > pageHeight) {
            let end = proxy.$el.querySelector('.page-end');
            if (end) {
              end.classList.add('html2pdf__page-break');
            }
          }
          proxy.$emit('generatePDF', true);
        });
      });
    }

    return {
      proxy,
      model,
      dbOptions,
      columnsReport,
      numberText,
      formatAmount,
    };
  },
};
</script>

<style lang="scss" scoped>
.report-c408-offline {
  .ms-grid-viewer:deep {
    padding: 0 6px !important;
    .ms-col-td {
      border-left: 1px solid !important;
      border-right: none !important;
    }
    .ms-thead {
      .ms-th {
        background: #ffffff !important;
        border-bottom: 1px solid !important;
        border-top: 1px solid !important;
      }
      .ms-col-th {
        border-left: 1px solid !important;
        border-right: none !important;
        .ms-th-content {
          .fs-big {
            font-size: 13px !important;
            margin: 3px 0px !important;
          }
        }
      }
      .ms-col-th-last {
        border-right: 1px solid !important;
      }
      .ms-th-title {
        .text-left {
          text-align: center !important;
        }
      }
    }
    .ms-tbody {
      tr:last-child {
        .text-left {
          text-align: right !important;
          font-weight: 700 !important;
        }
      }
    }

    .row-selected td {
      background-color: #ffffff !important;
    }
    .ms-content--table {
      .ms-tr {
        .ms-col-td-last {
          border-right: 1px solid !important;
          .text-left {
            text-align: right;
          }
        }
      }
      .ms-td {
        border-bottom: 1px solid;
      }
    }

    tr.border-top {
      td {
        border-top: 1px solid black;
      }
    }
  }
}
.print-text-left {
  text-align: left;
  padding-left: 6px;
}

html {
  overflow: hidden;
}

.bold {
  font-weight: 700;
}

.italic {
  font-style: italic;
}

.row {
  display: -webkit-flex;
  display: flex;
}

.flex {
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.flex-2 {
  -webkit-flex: 2;
  flex: 2;
  min-width: 0;
  min-height: 0;
}
.flex-3 {
  -webkit-flex: 3;
  flex: 3;
  min-width: 0;
  min-height: 0;
}
.flex-4 {
  -webkit-flex: 4;
  flex: 4;
  min-width: 0;
  min-height: 0;
}
.flex-5 {
  -webkit-flex: 5;
  flex: 5;
  min-width: 0;
  min-height: 0;
}

.break-word {
  overflow-wrap: break-word;
}

.center {
  text-align: center;
}

.hidden {
  display: none !important;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

body {
  padding: 0;
  margin: 0;
  background-size: 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  /*kích thước mặc định là 12*/
  font-size: 12pt;
  letter-spacing: 0.3px;
}

body:not(.a5) {
  font-size: 12pt;
  width: 794px;
}

body.a4.landscape {
  font-size: 12pt;
  /*min-height: 794px;*/
  width: 1123px !important;
}

body.a4.landscape .container {
  /*min-height: 794px;*/
  /* width: 1123px !important; */
}

body.a5.landscape .container {
  /*height: 559px;*/
  /* width: 21cm !important; */
}

/*nxhoa 27.10.2023: để line-height: normal để tự động co dãn theo cỡ chữ, chỗ nào cần fix thì custom riêng*/
body:not(.a5),
body:not(.a5) table .edit-item:not(tr):not(td) {
  line-height: normal;
}

body:not(.a5) .header .edit-item {
  /*nxhoa 27.10.2023: để line-height: normal để tự động co dãn theo cỡ chữ, chỗ nào cần fix thì custom riêng*/
  line-height: normal;
}

body.a5,
body.a5 table .edit-item {
  /*nxhoa 27.10.2023: để line-height: normal để tự động co dãn theo cỡ chữ, chỗ nào cần fix thì custom riêng*/
  line-height: normal;
}

/*nxhoa 27.10.2023: Do set line-height normal nên set padding top chung cho các dòng sửa mẫu là 1-2px để đảm bảo các dòng cách nhau cho dễ nhìn
    class này để vào đầu container của mẫu để áp dụng 
*/
.pd-top-edit-item-2 .edit-group .edit-item {
  padding-top: 2px;
}

.pd-top-edit-item-1 .edit-group .edit-item {
  padding-top: 1px;
}

.container {
  position: relative;
  width: auto !important;
  overflow: visible;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff !important;
}

.data-value {
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.number {
  text-align: right;
  white-space: nowrap;
}

.nowrap {
  white-space: nowrap;
}

.logo-company {
  background-repeat: no-repeat;
  background-position-x: 0px;
  background-position-y: center;
}

.table-detail {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-collapse: collapse;
  font-size: 11pt;
}

.table-detail td {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  padding: 4px 2px;
}

.table-detail td.thead {
  padding: 2px;
}

.table-detail tr td span {
  display: inline-block;
}

.table-detail .cell {
  padding: 2px 4px;
}

.detail {
  position: relative;
}

.template-table {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.clear {
  clear: both;
}

.image-template {
  position: absolute;
  z-index: -1;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
/** A5 ngang */
.a5.landscape .image-template {
  max-height: 559px !important;
}

/* A4 dọc */
body:not(.a5):not(.landscape) .image-template {
  max-height: 1118px !important;
}

/* A4 ngang */
body.landscape:not(.a5) .image-template {
  max-height: 785px !important;
}

.logo-template.left {
  margin-right: 16px;
}

.logo-template.right {
  margin-left: 16px;
}

.logo-template.center {
  margin: auto;
}

.logo-template {
  position: relative;
  z-index: -1;
  background-size: 100% 100%;
}

.table-detail {
  word-break: break-word;
}

.table-detail .number,
table .number,
.line_number {
  font-size: 10pt;
  /*        font-family: Arial;*/
}

.template-number {
  width: 280px;
}

/*
* nxhoa 25.10.2023: Cái dòng chữ in nghiêng dưới mã biểu mẫu để dòng sát nhau hơn bình thường chút
* style này ăn chung cho tất cả các mẫu
*/
body .header .edit-item.issue-by {
  /*line-height: normal;*/
  /*padding-top: 4px;*/
}

.w-10 {
  width: 10%;
}

.w-20 {
  width: 20%;
}

.w-30 {
  width: 30%;
}

.w-40 {
  width: 40%;
}

.w-50 {
  width: 50%;
}

.w-60 {
  width: 60%;
}

.w-70 {
  width: 70%;
}

.w-80 {
  width: 80%;
}

.w-90 {
  width: 90%;
}

.w-100 {
  width: 100%;
}

.bt-0 {
  border-top: none !important;
}

.br-0 {
  border-right: none !important;
}

.bl-0 {
  border-left: none !important;
}

.bb-0 {
  border-bottom: none !important;
}

.table-valign-top td {
  vertical-align: top;
}

.page-margin-content {
  padding-left: 0;
  padding-right: 0;
}

.page-margin-top {
  padding-top: 0;
}

.page-margin-bottom {
  padding-bottom: 0;
}

.sign-label {
  height: 140px;
  font-size: 11pt;
}

.a5 .sign-label {
  height: 72px;
}

.a4.landscape .container {
  /* width: 1170px; */
}

.a5:not(.landscape) .container {
  /* width: 585px; */
}

.sign-label .sub {
  font-size: 10pt;
  font-style: italic;
  padding-top: 2px;
}

.logo-company-left {
  padding-right: 4px;
}

.tb-sign td {
  vertical-align: top;
}

.edit-item {
}

.customizable {
  font-size: 0;
}

.customizable:not(.tablefooter) .edit-item {
  display: inline-block;
  vertical-align: top;
  max-width: 100%;
}

body:not(.a5)
  .customizable:not(.tablefooter)
  .edit-item:not(.report-title):not(.report-sub-title-italic-bold):not(.report-sub-title-italic):not(
    .report-sub-title
  ):not(.report-sub-title-italic-bold) {
  font-size: 12pt;
}

body.a5
  .customizable:not(.tablefooter)
  .edit-item:not(.report-title):not(.report-sub-title-italic-bold):not(.report-sub-title-italic):not(
    .report-sub-title-italic-bold
  ) {
  font-size: 12pt;
}

.w-100 {
  width: 100%;
}

.w-50 {
  width: 50%;
}

.d-block {
  display: block;
}

.d-inline-block {
  display: block;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.sign-value {
  /*white-space: nowrap;*/
}

.break-page {
  page-break-inside: avoid;
}

/*style các vùng thông tin - đồng bộ với style báo cáo stimul*/
/*mẫu số*/
.form-no {
  font-weight: 700;
  font-size: 16px;
}

.issue-by {
  font-size: 13px;
  font-style: italic;
  text-align: center;
}

.report-title {
  font-size: 23px;
  font-weight: 700;
  text-align: center;
}

.report-sub-title {
  font-size: 12pt;
  text-align: center;
}

.report-sub-title-2 {
  font-size: 12pt;
  text-align: center;
}

.report-sub-title-italic {
  font-size: 12pt;
  font-style: italic;
  text-align: center;
}

.report-sub-title-italic-bold {
  font-size: 12pt;
  font-weight: 700;
  font-style: italic;
  text-align: center;
}

.summary-word {
  font-weight: 700;
  font-style: italic;
}

.detail-header {
  font-size: 12pt;
  font-weight: 700;
}

.double-line {
  width: 100%;
  border-top: 1pt dotted #000;
  position: fixed;
  top: 50%;
  left: 0;
}

.a5 .double-line {
  width: 100%;
  border-top: 1px dotted #ddd;
  position: fixed;
  top: 100%;
  left: 0;
}

[data-group='license'] {
  font-size: 18px;
}

.header-row {
  line-height: normal;
}

.table-summary {
  font-weight: 700;
}

.divier-table-and-sign {
  height: 28px;
}

.in-word {
  font-weight: bold;
  font-style: italic;
}

.table-footer {
  border-style: solid;
  border-width: 0 1px;
}

.table-footer .edit-item {
  border-bottom: 1px solid;
  padding-top: 4px;
  line-height: normal;
  font-size: 11pt !important;
}

.table-footer .edit-value {
  padding: 0 4px;
  float: right;
  font-weight: 700;
}

/*
* nxhoa 24.10.2023: để display: inline; để dữ liệu nội dung dài nối tiếp trên dòng
*/
span.edit-field,
span.edit-value {
  display: inline;
  vertical-align: top;
}

.break .edit-group.table-footer:first-child {
  border-top: solid 1px #776b6b;
}

.left-column {
  width: 72%;
}

.right-column {
  width: 25%;
}

.edit-group.tablefooter {
  border-style: solid;
  border-width: 0 1px;
}

.edit-group.tablefooter .edit-item {
  border-bottom: 1px solid;
  font-size: 11pt;
  line-height: 25px;
  display: inline-block;
  height: 25px;
}

.edit-group.tablefooter .edit-value {
}

.edit-group.tablefooter .amount-in-words {
  height: auto;
  min-height: 25px;
}

body.a5 .edit-group.tablefooter .edit-item {
  font-size: 10pt;
}

.ml-2 {
  margin-left: 2px;
}

.a5.landscape .edit-group.sign .sign-label,
.a5.landscape .edit-group.sign .sub,
.a5.landscape .edit-group.sign .sign-value {
  font-size: 10pt;
}

.a5.landscape .edit-group.tablefooter .edit-item {
  height: 23px;
}

.h-100 {
  height: 100%;
}

.margin-left-50 {
  margin-left: 50%;
}

.font-weight-nomal {
  font-weight: normal;
}

/*Class tương ứng với font-face trên stimul*/

.bc-form-no {
  font-size: 12pt;
  font-family: 'Times New Roman';
  font-weight: bold;
}

.bc-issue-by {
  font-size: 9.5pt;
  font-family: 'Times New Roman';
  font-style: italic;
  letter-spacing: 0;
}
.ct-issue-by {
  font-size: 9.75pt;
  font-family: 'Times New Roman';
  letter-spacing: 0;
}

.bc-title {
  font-size: 16pt;
  font-family: 'Times New Roman';
  font-weight: bold;
}

.bc-sub-title {
  font-size: 12pt;
  font-family: 'Times New Roman';
}

.bc-unit {
  font-size: 12pt;
  font-family: 'Times New Roman';
  font-style: italic;
}

.bc-label-text {
  font-size: 12pt;
  font-family: 'Times New Roman';
}

.bc-table-header {
  font-size: 10pt;
  font-family: 'Times New Roman';
  font-weight: bold;
}

.bc-table-sub-header {
  font-size: 10pt;
  font-family: 'Times New Roman';
  text-align: center;
}

.bc-sign-org {
  font-size: 11pt;
  font-family: 'Times New Roman';
  font-weight: bold;
}

.bc-sign-title {
  font-size: 11pt;
  font-family: 'Times New Roman';
  font-weight: bold;
}

.bc-sign-sub-title {
  font-size: 11pt;
  font-family: 'Times New Roman';
  font-style: italic;
}

.bc-sign-date,
.sign-date {
  font-size: 11pt;
  font-family: 'Times New Roman';
  font-style: italic;
  text-align: center;
}

.ct-sign-title {
  font-size: 12pt;
  font-family: 'Times New Roman';
  font-weight: bold;
  text-align: center;
}

.ct-sign-subtitle {
  font-size: 9.75pt;
  font-family: 'Times New Roman';
  font-style: italic;
  text-align: center;
}

.ct-table-detail-number {
  font-size: 9pt;
  font-family: 'Arial Narrow';
}
.ct-table-detail-text {
  font-size: 10pt;
  font-family: 'Times New Roman';
}

.ct-table-summary-detail-number {
  font-size: 9pt;
  font-family: 'Arial Narrow';
  font-weight: bold;
}

.ct-table-summary-detail-text {
  font-size: 10pt;
  font-family: 'Arial Narrow';
  font-weight: bold;
}

.ct-summary-text-number {
  font-size: 11pt;
  font-family: 'Times New Roman';
  font-style: italic;
}

.bc-table-detail-text {
  font-size: 10pt;
  font-family: 'Times New Roman';
}

.bc-table-detail-number {
  font-size: 9pt;
  font-family: 'Arial Narrow';
}

.ct-title {
  font-size: 14pt;
  font-family: 'Times New Roman';
  font-weight: bold;
}

.ct-title-13 {
  font-size: 13pt;
  font-family: 'Times New Roman';
  font-weight: bold;
}

.ct-text-frame {
  font-size: 12pt;
  font-family: 'Times New Roman';
  text-align: center;
}

.pd-top-8 {
  padding-top: 8px;
}

.pd-top-4 {
  padding-top: 4px;
}

.pd-top-2 {
  padding-top: 2px;
}

.pd-bot-8 {
  padding-bottom: 8px;
}

.pd-bot-4 {
  padding-bottom: 4px;
}

.pd-bot-2 {
  padding-bottom: 2px;
}

.table-detail td.td-row-dotted {
  border-top: none;
  border-bottom: 1px dotted black;
}

body {
  color: #000000;
  font-family: 'Times New Roman';
}
.container {
  padding-top: 1cm;
  padding-right: 1cm;
  padding-bottom: 0.5cm;
  padding-left: 1cm;
}
.image-template {
  opacity: 1;
  height: 500px;
  width: 500px;
  top: 0;
  left: 0;
}
.logo-template {
  height: 70px;
  width: 70px;
  top: 0;
  left: 0;
}
.sign-label {
  font-size: 10pt;
}
.sign-label .sub {
  font-size: 10pt;
}
.sign-value {
  font-size: 10pt;
}
.detail-header {
  font-size: 10pt;
}
.detail-data {
  font-size: 10pt;
}
.table-detail .number,
table .number,
.line_number {
  font-size: 9pt;
}
.table-summary {
  font-size: 10pt;
}

.detail-text {
  font-size: 11.25pt;
  font-family: 'Times New Roman';
}

.block-border-empty {
  position: absolute;
  width: 127px;
  padding: 10px;
  text-align: center;
  border: 1px solid black;
  top: -20px;
  left: 10px;
}

.block-border-empty-2 {
  width: 160px;
}

[data-group='master-2'] .edit-item:not([data-field='title-1']) {
  padding: 0px 10px 0px 10px;
}
</style>
